export default 'm23.77 5.745-3.645-3.668-12.202 12.28-4.278-4.306L0 13.719l7.923 7.973L23.77 5.745Z';
